import { render, staticRenderFns } from "./MetricArrivals.vue?vue&type=template&id=f6ee0770&"
import script from "./MetricArrivals.vue?vue&type=script&lang=js&"
export * from "./MetricArrivals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports